import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Button } from "@cirrus/ui-kit-ts/src/components/atoms/Button"
import { MatSymbol } from "@cirrus/ui-kit-ts/src/components/atoms/MatSymbol"

import { useCustomerInfo } from "../../../CustomerInfo"
import { AlternativeLoginButtons } from "../../containers/AlternativeLoginButtons"

const AUTHOR_BTN_ID = "author-btn-id"
const DELIVERY_BTN_ID = "delivery-btn-id"
const DELIVERY_NEW_BTN_ID = "delivery-new-btn-id"

export const RoleScreenContent = () => {
  const { i18n } = useTranslations()
  const { data } = useCustomerInfo()

  const deliveryLabel = i18n("StartPage:Delivery")
  const deliveryNewLabel = i18n("StartPage:NeoDelivery")
  const authorLabel = i18n("StartPage:Author")

  return <AlternativeLoginButtons>
    {/*
      Using jsx link element instead of navigation hook because of issues between routers.
      This approach might be not Storybook friendly, though
    */}

    <a href="author/app" title={authorLabel}>
      <Button fullWidth label={authorLabel} variant="outlined"
              id={AUTHOR_BTN_ID}
              sx={{ bgcolor: "login.bg", borderColor: "login" }}
              color="login" className={"role-button"}
              startIcon={<MatSymbol color="login" name="edit_square" />} />
    </a>

    <a href="delivery/app" title={deliveryLabel}>
      <Button fullWidth label={deliveryLabel} variant="outlined"
              id={DELIVERY_BTN_ID}
              sx={{ bgcolor: "login.bg", borderColor: "login" }}
              color="login" className={"role-button"}
              startIcon={<MatSymbol color="login" name="send" />} />
    </a>

    {
      data?.enableDeliveryV2
      &&
      <a href="delivery-v2/app" title={deliveryNewLabel}>
        <Button fullWidth label={deliveryNewLabel} variant="outlined"
                id={DELIVERY_NEW_BTN_ID}
                sx={{ bgcolor: "login.bg", borderColor: "login" }}
                color="login" className={"role-button"}
                startIcon={<MatSymbol color="login" name="send" />} />
      </a>
    }
  </AlternativeLoginButtons>
}
